import { UserAvatar } from 'Components/shared/UserAvatar';
import React from 'react';
import { useTypingIndicatorAnalytics } from '../../hooks/useTypingIndicatorAnalytics';
import { useTypingIndicatorAnnouncement } from '../../hooks/useTypingIndicatorAnnouncement';
import { useTypingPersons } from '../../hooks/useTypingPersons';
import { AvatarTypingIndicatorProps } from './index.types';

export const AvatarTypingIndicator: React.FC<AvatarTypingIndicatorProps> = ({
  conversationId,
}) => {
  const { firstPersons, additionalPersons } = useTypingPersons(conversationId);
  const isVisible = firstPersons.length > 0;

  useTypingIndicatorAnnouncement([...firstPersons, ...additionalPersons]);
  useTypingIndicatorAnalytics(conversationId, isVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="flex items-center gap-[10px] px-[5px]" aria-hidden="true">
      <div className="flex -space-x-[18px]">
        {firstPersons.map(({ contact, presence }) => {
          return (
            <UserAvatar
              key={contact.id}
              size={32}
              conversationId={conversationId}
              name={contact.name}
              image={contact.avatarUrl}
              presence={firstPersons.length === 1 ? presence : undefined}
            />
          );
        })}
        {additionalPersons.length > 0 && (
          <div className="relative flex items-center justify-center size-[32px] rounded-full bg-border-legacy text-secondary-foreground">
            +{additionalPersons.length}
          </div>
        )}
      </div>

      <div className="relative flex items-center justify-center gap-[4px] w-[54px] h-[32px] border-[1px] border-border rounded-lg bg-background after:content-[''] after:absolute after:top-[10px] after:left-[-6px] after:size-[11px] after:rotate-[-45deg] after:bg-background after:border-t after:border-l after:border-border">
        <div className="animate-typing-dot size-[8px] rounded-full" />
        <div className="animate-typing-dot size-[8px] rounded-full" />
        <div className="animate-typing-dot size-[8px] rounded-full" />
      </div>
    </div>
  );
};
